export const DEFAULT_TEMPLATES_PAGESIZE = 8;
export const DEFAULT_CAMPAIGNS_PAGESIZE = 10;